var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step_side"},[_c('div',{staticClass:"side_header"},[_c('div',{staticClass:"side_title"},[_vm._v(_vm._s(_vm.msg.name))]),_c('div',{staticClass:"side_id"},[_vm._v(_vm._s(_vm.msg.id))])]),_c('step',{staticClass:"step"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }